import { computed, ref } from 'vue'

export function useApiErrors() {
  const errors = ref(null)

  const formattedErrors = computed(() => {
    return Object.keys(errors.value ?? {}).reduce((carry, key) => {
      carry[key] = errors.value[key].join(' ')
      return carry
    }, {})
  })

  function clearErrors() {
    errors.value = null
  }

  function setErrors(newErrors) {
    errors.value = newErrors
  }

  function hasError(field) {
    return !!errors.value?.[field]
  }

  function getError(field) {
    if (!hasError(field)) {
      return null
    }

    return errors.value[field].join('\n')
  }

  return {
    hasError,
    getError,
    setErrors,
    clearErrors,
    formattedErrors,
  }
}
